import React, { useRef, lazy, Suspense } from 'react';

import { Balloon, Feedback, Radio } from '@icedesign/base';

import { connect } from 'react-redux';

import { formatMessage } from '@/i18n';
import { setTheme, setWideScreen } from '@/store/actions/SystemActions';
import Colors from '@/tool/Colors';

import ScreenModeDialog from './ScreenModeDialog';

const FaBrush = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaBrush })));

const FaChevronRight = lazy(() =>
  import('react-icons/fa').then(mod => ({ default: mod.FaChevronRight }))
);

const FaHatWizard = lazy(() =>
  import('react-icons/fa').then(mod => ({ default: mod.FaHatWizard }))
);

const FaTv = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaTv })));

const ScreenWidget = ({ theme, wideScreen, dispatch }) => {
  const screenModeDialog = useRef(null);

  const selectWideScreen = isWideScreen => {
    if (isWideScreen !== wideScreen) {
      dispatch(setWideScreen(isWideScreen));
      Feedback.toast.success(
        formatMessage('system.screen.mode.change.success', '', {
          mode: isWideScreen
            ? formatMessage('system.screen.mode.wide')
            : formatMessage('system.screen.mode.narrow'),
        })
      );
    }
  };

  const selectTheme = selectedTheme => {
    dispatch(setTheme(selectedTheme));
  };

  return (
    <>
      <Balloon
        trigger={
          <div className="setting-screen">
            <Suspense fallback={null}>
              <FaHatWizard size={16} />
            </Suspense>
          </div>
        }
        style={styles.container}
        closable={false}
        align="l"
      >
        <div>
          <Item
            prefixIcon={
              <Suspense fallback={null}>
                <FaTv />
              </Suspense>
            }
            title={formatMessage('system.screen.mode')}
            suffixColor={Colors.warning}
          >
            <div style={styles.mode} onClick={() => screenModeDialog.current?.open(wideScreen)}>
              {wideScreen
                ? formatMessage('system.screen.mode.wide')
                : formatMessage('system.screen.mode.narrow')}
              <Suspense fallback={null}>
                <FaChevronRight size={12} />
              </Suspense>
            </div>
          </Item>
          {!wideScreen && (
            <Item
              prefixIcon={
                <Suspense fallback={null}>
                  <FaBrush />
                </Suspense>
              }
              title={formatMessage('menu.theme')}
            >
              <Radio.Group value={theme} onChange={selectTheme} size="small" shape="button">
                <Radio id="light" value="light">
                  {formatMessage('menu.theme.light')}
                </Radio>
                <Radio id="dark" value="dark">
                  {formatMessage('menu.theme.dark')}
                </Radio>
              </Radio.Group>
            </Item>
          )}
        </div>
      </Balloon>
      <ScreenModeDialog
        ref={screenModeDialog}
        wideScreen={wideScreen}
        onSelect={selectWideScreen}
      />
    </>
  );
};

const Item = ({ prefixIcon, title, children }) => {
  return (
    // 为了支持IE10的flexbox;
    <div style={styles.item} className="header-sdk-item">
      <div style={styles.title}>
        {prefixIcon}&nbsp;&nbsp;{title}
      </div>
      {children}
    </div>
  );
};

function mapStateToProps(store) {
  return {
    wideScreen: store.systemReducer.wideScreen,
    theme: store.systemReducer.theme,
  };
}

export default connect(mapStateToProps)(ScreenWidget);

const styles = {
  container: {
    borderRadius: 8,
    padding: '5px 18px',
    maxWidth: 1000, // 不写最大默认还是300px，会导致过长时显示内容异常换行
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '18px 0px',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '60px',
  },
  suffix: {
    padding: '3px 5px',
    color: 'white',
    borderRadius: '8px',
    // 使用css3特性transform强制缩小字体
    transform: 'scale(0.8)',
  },
  mode: {
    display: 'flex',
    alignItems: 'center',
    color: Colors.primary,
    cursor: 'pointer',
  },
};
